import type { ApiDashboardType } from '../../../apps/api-hono/src/routes/api_dashboard/_router'
import { hc } from 'hono/client'
import { getEnvVariable } from '@lib/utils/getEnvVariable';
import { getClientRequestOptions } from './getClientRequestOptions';

const client = hc<ApiDashboardType>('')
type Client = typeof client
const createDashboardApiClient = (...args: Parameters<typeof hc>): Client => {
    return hc<ApiDashboardType>(...args)
}

export const dashboardApiClient = createDashboardApiClient(
    `https://${getEnvVariable('PUBLIC_API_DOMAIN')}/dashboard/`,
    getClientRequestOptions()
)

